module.exports = __webpack_public_path__ + "static/paris-018.thumb-adbef4f0673e34905a2d5d6a646d9126.jpg";